import { adoptionPreflightRefusalFromError } from "@/api/library";
import { PLACEMENT_REFUSAL_LABEL } from "@/lib/labels";

/**
 * The refused pins of a `409 adoption_preflight_refused`, each named and
 * explained, or nothing (#859).
 *
 * Shared by every BG write surface since #914 — the adoption picker and the
 * interview-profile control both refuse through the same envelope, and one
 * rendering is what keeps the two from explaining the same refusal differently.
 *
 * `null` for every other failure — a 401, a 409 on the adoptions version, a
 * transport error — so the envelope's own sentence above stands alone rather
 * than being followed by an empty list.
 */
export function PreflightReasons({
  error,
  names,
}: {
  error: unknown;
  /** Asset id → the name this surface shows for it. */
  names: ReadonlyMap<string, string>;
}) {
  const refusal = adoptionPreflightRefusalFromError(error);
  if (refusal === null) {
    return null;
  }
  return (
    <ul className="mt-2 space-y-1">
      {refusal.refusals.map((item) => {
        const label = PLACEMENT_REFUSAL_LABEL[
          item.reason as keyof typeof PLACEMENT_REFUSAL_LABEL
        ] as string | undefined;
        return (
          <li key={`${item.assetId}:${item.version}`}>
            {names.get(item.assetId) ?? item.assetId} at {item.version}
            {label ? `: ${label}.` : "."}
          </li>
        );
      })}
    </ul>
  );
}
